<template>
    <div class="content-account-header">
        <template v-if="this.$route.name == 'Account'">
            <button class="content-account-header-text btn-return">
                <h3>as suas participações</h3>
            </button>
        </template>
        <template v-else>
            <button class="content-account-header-text btn-return" tag="a" @click="hasHistory() 
                ? $router.go(-1) 
                : $router.push('/')">
                <img src="@/assets/img/round-arrow-left.png" alt="round arrow back">
                <h3>as suas participações</h3>
            </button>
        </template>
        
        <div class="content-account-header-clock" v-if="shouldShowClock">
            <div class="content-account-header-clock-text ">
                <p>Grande Sorteio faltam:</p>
                <div class="content-account-header-clock-text-counter">
                    <p><span>30</span> dias: <span>4</span> horas: <span>15</span> min</p>
                </div>
            </div>
            <div class="content-account-header-clock-img">
                <img src="@/assets/img/account/rise_mockup.png" alt="rise mockup">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    shouldShowClock() {
        return false;
    //   return this.screenWidth >= 992 && this.$route.name === 'AccountCode';
    },
  },
  created() {
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    hasHistory() {
        return window.history.length > 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.content-account-header{
        width: 100%;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 992px){
            flex-direction: column-reverse;
            align-items: flex-start;
        }
        &-text {
            all: unset;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            h3::first-letter{
                text-transform: capitalize;
            }
        }
        &-clock{
            width: 325px;
            height: 100px;
            position: relative;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            &-text{
                width: 292px;
                p{
                    font-family: 'Font Bold';
                    font-size: 18px;
                    color: var(--main-color);
                    text-transform: uppercase;
                    margin: 0;
                    text-align: end;
                }
                &-counter{
                    height: 43px;
                    width: 292px;
                    background: rgb(31,125,101);
                    background: linear-gradient(90deg, rgba(31,125,101,1) 0%, rgba(0,179,115,1) 100%);
                    border-radius: 30px;
                    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
                    padding: 0 30px;
                    p{
                        font-family: 'Font Regular';
                        color: var(--white);
                        text-transform: lowercase;
                        span{
                            font-family: 'Font Bold';
                            color: var(--white);
                            font-size: 24px;
                            line-height: 24px;
                        }
                    };
                }
            
                
            }
            &-img{
                position: absolute;
                left: 0;
                top: 0;
                img{
                    width: 100px;
                    height: 100px;
                }
            }
            
        }
    }
</style>